import { ShieldCheck, Bell, Mail } from "lucide-react";

const ROWS = [
  ["Gas Safety Certificate (CP12)", "green", "Valid · 214 days"],
  ["EICR", "green", "Valid · 3 yrs"],
  ["Energy Performance Certificate", "amber", "Expires in 23 days"],
  ["Rent Smart Wales Licence", "green", "Renews 2027"],
  ["Deposit protected", "red", "Not uploaded"],
];
const DOT = { green: "bg-emerald-400", amber: "bg-amber-400", red: "bg-rose-400" };

export default function HeroMock() {
  return (
    <div className="relative mx-auto w-full max-w-md lg:max-w-none" aria-hidden>
      <div className="absolute -inset-6 rounded-[2rem] bg-emerald-glow/20 blur-3xl" />
      <div className="relative rounded-3xl border border-white/10 bg-white/[0.06] backdrop-blur-xl p-5 shadow-2xl animate-fade-up" style={{ animationDelay: "150ms" }}>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-wider text-white/50">Portfolio score</p>
            <p className="font-heading text-4xl font-extrabold text-white leading-none mt-1">86<span className="text-base text-white/40">/100</span></p>
          </div>
          <div className="relative h-16 w-16">
            <svg viewBox="0 0 36 36" className="h-16 w-16 -rotate-90"><circle cx="18" cy="18" r="15.5" fill="none" stroke="rgba(255,255,255,.12)" strokeWidth="3" /><circle cx="18" cy="18" r="15.5" fill="none" stroke="#10B981" strokeWidth="3" strokeDasharray="97.4" strokeDashoffset="13.6" strokeLinecap="round" className="animate-ring" /></svg>
            <ShieldCheck size={22} className="absolute inset-0 m-auto text-emerald-glow" />
          </div>
        </div>
        <div className="mt-4 space-y-2">
          {ROWS.map(([name, s, label], i) => (
            <div key={name} className="flex items-center gap-3 rounded-xl bg-white/[0.05] px-3 py-2.5 animate-fade-up" style={{ animationDelay: `${300 + i * 90}ms` }}>
              <span className={`h-2.5 w-2.5 rounded-full ${DOT[s]} shadow-[0_0_12px_currentColor]`} />
              <span className="flex-1 text-sm text-white/90 truncate">{name}</span>
              <span className="text-[11px] text-white/50 whitespace-nowrap">{label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="absolute -right-3 -top-5 sm:-right-8 rounded-2xl bg-white text-navy shadow-xl px-4 py-3 hidden sm:flex items-center gap-3 animate-float">
        <span className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-50 text-emerald-brand"><Mail size={18} /></span>
        <div><p className="text-xs font-semibold">Certificate filed</p><p className="text-[11px] text-slate-500">via email-in · 2 min ago</p></div>
      </div>
      <div className="absolute -left-3 -bottom-5 sm:-left-8 rounded-2xl bg-white text-navy shadow-xl px-4 py-3 hidden sm:flex items-center gap-3 animate-float" style={{ animationDelay: "1.2s" }}>
        <span className="grid h-9 w-9 place-items-center rounded-xl bg-amber-50 text-amber-600"><Bell size={18} /></span>
        <div><p className="text-xs font-semibold">EPC due in 23 days</p><p className="text-[11px] text-slate-500">Reminder sent · 08:00</p></div>
      </div>
    </div>
  );
}
